import { render, staticRenderFns } from "./CloudCoverageThreshold.vue?vue&type=template&id=96cc54e4&lang=html&"
import script from "./CloudCoverageThreshold.vue?vue&type=script&lang=js&"
export * from "./CloudCoverageThreshold.vue?vue&type=script&lang=js&"
import style0 from "./CloudCoverageThreshold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports